import { Box, Typography } from '@mui/material'

export default function TotalSeats() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1,
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '13.29px',
            lineHeight: '100%',
            letterSpacing: '0%',
            verticalAlign: 'middle',
            color: '#06004A',
            gap: 1,
          }}
        >
          Total Seats
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '13.29px',
            lineHeight: '100%',
            letterSpacing: '0%',
            verticalAlign: 'middle',
            color: '#06004A',
            gap: 1,
            background: '#F2F2F2',
          }}
        >
          <svg
            width='12'
            height='10'
            viewBox='0 0 12 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M4.74947 3.9998C5.71595 3.9998 6.49943 3.21632 6.49943 2.24984C6.49943 1.28336 5.71595 0.499878 4.74947 0.499878C3.78299 0.499878 2.99951 1.28336 2.99951 2.24984C2.99951 3.21632 3.78299 3.9998 4.74947 3.9998Z'
              stroke='#1705E5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M8.15198 0.750122C8.66017 1.05634 9.00006 1.61353 9.00006 2.25009C9.00006 2.88665 8.66017 3.44384 8.15198 3.75005'
              stroke='#1705E5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M1 9.20017V9.50016H8.49983V9.20017C8.49983 8.0801 8.49983 7.52006 8.28186 7.09224C8.09011 6.71593 7.78415 6.40996 7.40783 6.21821C6.98001 6.00024 6.41998 6.00024 5.2999 6.00024H4.19993C3.07985 6.00024 2.51982 6.00024 2.092 6.21821C1.71568 6.40996 1.40972 6.71593 1.21798 7.09224C1 7.52006 1 8.0801 1 9.20017Z'
              stroke='#1705E5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M11.0004 9.49948V9.19949C11.0004 8.07941 11.0004 7.51937 10.7825 7.09156C10.5907 6.71524 10.2848 6.40927 9.90845 6.21753'
              stroke='#1705E5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </svg>
          128
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <Box
          sx={{
            width: '100px',
            display: 'flex',
            gap: 3,
            flexDirection: 'column',
            background: '#F5F5F5',
            angle: '-180 deg',
            padding: '10px',
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            borderRight: '1px solid #D6D6D6',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '8px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            <svg
              width='12'
              height='10'
              viewBox='0 0 12 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.74947 3.9998C5.71595 3.9998 6.49943 3.21632 6.49943 2.24984C6.49943 1.28336 5.71595 0.499878 4.74947 0.499878C3.78299 0.499878 2.99951 1.28336 2.99951 2.24984C2.99951 3.21632 3.78299 3.9998 4.74947 3.9998Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M8.15198 0.750122C8.66017 1.05634 9.00006 1.61353 9.00006 2.25009C9.00006 2.88665 8.66017 3.44384 8.15198 3.75005'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M1 9.20017V9.50016H8.49983V9.20017C8.49983 8.0801 8.49983 7.52006 8.28186 7.09224C8.09011 6.71593 7.78415 6.40996 7.40783 6.21821C6.98001 6.00024 6.41998 6.00024 5.2999 6.00024H4.19993C3.07985 6.00024 2.51982 6.00024 2.092 6.21821C1.71568 6.40996 1.40972 6.71593 1.21798 7.09224C1 7.52006 1 8.0801 1 9.20017Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M11.0004 9.49948V9.19949C11.0004 8.07941 11.0004 7.51937 10.7825 7.09156C10.5907 6.71524 10.2848 6.40927 9.90845 6.21753'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Editors
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 600,
              fontSize: '32px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#1705E5',
              marginBottom: 1,
            }}
          >
            14
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100px',
            display: 'flex',
            gap: 3,
            flexDirection: 'column',
            background: '#F5F5F5',
            padding: '10px',
            borderRight: '1px solid #D6D6D6',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '8px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            <svg
              width='12'
              height='10'
              viewBox='0 0 12 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.74947 3.9998C5.71595 3.9998 6.49943 3.21632 6.49943 2.24984C6.49943 1.28336 5.71595 0.499878 4.74947 0.499878C3.78299 0.499878 2.99951 1.28336 2.99951 2.24984C2.99951 3.21632 3.78299 3.9998 4.74947 3.9998Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M8.15198 0.750122C8.66017 1.05634 9.00006 1.61353 9.00006 2.25009C9.00006 2.88665 8.66017 3.44384 8.15198 3.75005'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M1 9.20017V9.50016H8.49983V9.20017C8.49983 8.0801 8.49983 7.52006 8.28186 7.09224C8.09011 6.71593 7.78415 6.40996 7.40783 6.21821C6.98001 6.00024 6.41998 6.00024 5.2999 6.00024H4.19993C3.07985 6.00024 2.51982 6.00024 2.092 6.21821C1.71568 6.40996 1.40972 6.71593 1.21798 7.09224C1 7.52006 1 8.0801 1 9.20017Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M11.0004 9.49948V9.19949C11.0004 8.07941 11.0004 7.51937 10.7825 7.09156C10.5907 6.71524 10.2848 6.40927 9.90845 6.21753'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Commenting Only
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 600,
              fontSize: '32px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#1705E5',
              marginBottom: 1,
            }}
          >
            44
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100px',
            display: 'flex',
            gap: 3,
            flexDirection: 'column',
            background: '#F5F5F5',
            padding: '10px',
            borderRight: '1px solid #D6D6D6',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '8px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            <svg
              width='12'
              height='10'
              viewBox='0 0 12 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.74947 3.9998C5.71595 3.9998 6.49943 3.21632 6.49943 2.24984C6.49943 1.28336 5.71595 0.499878 4.74947 0.499878C3.78299 0.499878 2.99951 1.28336 2.99951 2.24984C2.99951 3.21632 3.78299 3.9998 4.74947 3.9998Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M8.15198 0.750122C8.66017 1.05634 9.00006 1.61353 9.00006 2.25009C9.00006 2.88665 8.66017 3.44384 8.15198 3.75005'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M1 9.20017V9.50016H8.49983V9.20017C8.49983 8.0801 8.49983 7.52006 8.28186 7.09224C8.09011 6.71593 7.78415 6.40996 7.40783 6.21821C6.98001 6.00024 6.41998 6.00024 5.2999 6.00024H4.19993C3.07985 6.00024 2.51982 6.00024 2.092 6.21821C1.71568 6.40996 1.40972 6.71593 1.21798 7.09224C1 7.52006 1 8.0801 1 9.20017Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M11.0004 9.49948V9.19949C11.0004 8.07941 11.0004 7.51937 10.7825 7.09156C10.5907 6.71524 10.2848 6.40927 9.90845 6.21753'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Viewers
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 600,
              fontSize: '32px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#1705E5',
              marginBottom: 1,
            }}
          >
            123
          </Typography>
        </Box>
        <Box
          sx={{
            width: '100px',
            display: 'flex',
            gap: 3,
            flexDirection: 'column',
            background: '#F5F5F5',
            padding: '10px',
            borderTopRightRadius: '4px',
            borderBottomRightRadius: '4px',
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: '8px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#04002E',
            }}
          >
            <svg
              width='12'
              height='10'
              viewBox='0 0 12 10'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.74947 3.9998C5.71595 3.9998 6.49943 3.21632 6.49943 2.24984C6.49943 1.28336 5.71595 0.499878 4.74947 0.499878C3.78299 0.499878 2.99951 1.28336 2.99951 2.24984C2.99951 3.21632 3.78299 3.9998 4.74947 3.9998Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M8.15198 0.750122C8.66017 1.05634 9.00006 1.61353 9.00006 2.25009C9.00006 2.88665 8.66017 3.44384 8.15198 3.75005'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M1 9.20017V9.50016H8.49983V9.20017C8.49983 8.0801 8.49983 7.52006 8.28186 7.09224C8.09011 6.71593 7.78415 6.40996 7.40783 6.21821C6.98001 6.00024 6.41998 6.00024 5.2999 6.00024H4.19993C3.07985 6.00024 2.51982 6.00024 2.092 6.21821C1.71568 6.40996 1.40972 6.71593 1.21798 7.09224C1 7.52006 1 8.0801 1 9.20017Z'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
              <path
                d='M11.0004 9.49948V9.19949C11.0004 8.07941 11.0004 7.51937 10.7825 7.09156C10.5907 6.71524 10.2848 6.40927 9.90845 6.21753'
                stroke='#1705E5'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Engineering Partners
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Inter',
              fontWeight: 600,
              fontSize: '32px',
              lineHeight: '100%',
              letterSpacing: '0%',
              verticalAlign: 'middle',
              color: '#1705E5',
              marginBottom: 1,
            }}
          >
            03
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
